import React from 'react';

export function Card({ children, className = '', ...props }) {
    return (
        <div className={`bg-white rounded-[24px] shadow-card p-6 ${className}`} {...props}>
            {children}
        </div>
    );
}

export function FormHeader({ title, subtitle }) {
    return (
        <div className="text-center mb-6">
            <h2 className="text-2xl font-bold text-brand-navy tracking-tight">{title}</h2>
            {subtitle && <p className="mt-1.5 text-gray-500 text-sm leading-relaxed">{subtitle}</p>}
        </div>
    );
}

export function Divider({ text }) {
    return (
        <div className="flex items-center gap-3 my-5">
            <div className="flex-1 h-px bg-gray-200" />
            {text && <span className="text-xs text-gray-500 font-medium">{text}</span>}
            <div className="flex-1 h-px bg-gray-200" />
        </div>
    );
}
